/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {Helmet as ReactHelmet} from 'react-helmet'

const Helmet = ({title = 'Secret of the Source Code'}) => (
  <ReactHelmet>
    <title>{title}</title>
  </ReactHelmet>
)

export default Helmet
